import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { filter, map, Observable } from 'rxjs';
import { PillarNavItem } from '../../models/pillar-nav-item';
import { PillarsContentItem } from '../../models/pillars-detail-item';
import { FooterContent } from '../../models/footer-content';

@Injectable({
  providedIn: 'root',
})
export class DrupalService {

  private readonly http = inject(HttpClient);
  
  private readonly pillarNavUrl = `${environment.api.baseUrl}/api/menu_items/frtn-pillar-navigation`;
  private readonly detailUrl = `${environment.api.baseUrl}/api/v1/frtn-pillars/detail`;
  private readonly footerUrl = `${environment.api.baseUrl}/api/v1/global/footer`;

  public getNavItems(): Observable<PillarNavItem[]> {
    return this.http.get<PillarNavItem[]>(this.pillarNavUrl);
  }

  public getContent(uri: string): Observable<PillarsContentItem[]> {
    return this.http.get<PillarsContentItem[]>(this.detailUrl).pipe(
      map(data => data.filter(_ => _.content_ui_url === uri))
    );
  }

  public getFooter(): Observable<FooterContent[]> {
    return this.http.get<FooterContent[]>(this.footerUrl);
  }

  public getContentItem(id: number): Observable<PillarsContentItem | undefined> {
    return this.http.get<PillarsContentItem[]>(this.detailUrl).pipe(
      map(data => data.filter(_ => _.pillars_unique_id === id)),
      map(data => {
        return data?.length > 0 ? data[0] : undefined;
      })
    );
  }

}
